import React from 'react';
export type DialogConfig = {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  toggleDialog: () => void;
};
export const useDialog = (initialState: boolean = false): DialogConfig => {
  const [open, setOpen] = React.useState<boolean>(initialState);

  const openDialog = React.useCallback(() => {
    setOpen(true);
  }, []);
  const closeDialog = React.useCallback(() => {
    setOpen(false);
  }, []);
  const toggleDialog = React.useCallback(() => {
    setOpen((pre) => !pre);
  }, []);
  return {
    open,
    openDialog,
    closeDialog,
    toggleDialog,
  };
};
